import { Plugin } from '@nuxt/types';
import dayjs from '~/libraries/dayjs';

declare module 'vue/types/vue' {
  interface Vue {
    $dayjs: typeof dayjs;
  }
}

declare module '@nuxt/types' {
  interface NuxtAppOptions {
    $dayjs: typeof dayjs;
  }
  interface Context {
    $dayjs: typeof dayjs;
  }
}

const dayjsPlugin: Plugin = ({ i18n }, inject) => {
  dayjs.locale(i18n.locale);
  inject('dayjs', dayjs);
};

export default dayjsPlugin;
